import {request} from '../jslib/request'
const BASE_REQUEST = '/tms/customerGoodsCost'
const BASE_REQUEST2 = '/tms/customerGoodsCostDetail'
import axios from 'axios'


export function getCustomerInvoiceList(
  routeName,id,isCus,invoiceCompany,costProject,tax,shipName,isApply,oneId,accountType
) {
  return request({
      url:`${BASE_REQUEST}/getCustomerInvoiceList`,
      data:{
        routeName:routeName,
        cusSupId: id,
        isCus:isCus,
        invoiceCompany:invoiceCompany,
        costProject:costProject,
        tax:tax,
        shipName:shipName,
        isApply:isApply,
        oneId:oneId,
        accountType:accountType
      }
  })
}
export function updateCustomerGoodsCostGuazhang(
  obj
) {
  return request({
    url:`${BASE_REQUEST}/updateCustomerGoodsCostGuazhang`,
    data:obj
  })
}
export function updateCostHetongId(data) {
  // return request({
  //     url:`${BASE_REQUEST}/updateCostHetongId`,
  //     methods: 'post',
  //     data
  // })
  return axios({
    headers:{
      "Content-Type":"application/json"
    },
    data,
    url: `${BASE_REQUEST}/updateCostHetongId`,
    method: 'post',
  })
}

export function getInvoiceInfo(
  id,isCus
) {
  return request({
    url:`${BASE_REQUEST}/getInvoiceInfo`,
    data:{
      contactId: id,
      isCus:isCus,
    }
  })
}

export function getCustomerGoodsCostList(querydata) {
        return request({
            url:`${BASE_REQUEST}/getCustomerGoodsCostList`,
            data:querydata
        })
}

export function updateCustomerGoodsCost(
    obj
) {
    return request({
        url:`${BASE_REQUEST}/updateCustomerGoodsCost`,
        data:obj
    })
}
export function bindContract(
    obj
) {
    return request({
        url:`${BASE_REQUEST}/bindContract`,
        data:obj
    })
}

export function bindContractByCostDetailId(
  obj
) {
  return request({
      url:`${BASE_REQUEST}/bindContractByCostDetailId`,
      data:obj
  })
}


export function delCustomerGoodsCost(
    id
) {
    return request({
        url:`${BASE_REQUEST}/delCustomerGoodsCost`,
        data:{id: id}
    })
}

export function saveCustomerGoodsCost(
    obj
) {
    return request({
        url:`${BASE_REQUEST}/saveCustomerGoodsCost`,
        data:obj
    })
}

export function getCustomerGoodsCostDetailList(querydata) {
    return request({
        url:`${BASE_REQUEST2}/getCustomerGoodsCostDetailList`,
        data:querydata
    })
}

export function updateCustomerGoodsCostDetail(
    obj
) {
    return request({
        url:`${BASE_REQUEST2}/updateCustomerGoodsCostDetail`,
        data:obj
    })
}

export function delCustomerGoodsCostDetail(
    id
) {
    return request({
        url:`${BASE_REQUEST2}/delCustomerGoodsCostDetail`,
        data:{id: id}
    })
}

export function saveCustomerGoodsCostDetail(
    obj
) {
    return request({
        url:`${BASE_REQUEST2}/saveCustomerGoodsCostDetail`,
        data:obj
    })
}

export function calVirCostList(querydata) {
    return request({
        url:`${BASE_REQUEST2}/calVirCostList`,
        data:querydata
    })
}

export function getFlowNumList() {
  return request({
    url:`${BASE_REQUEST}/getFlowNumList`,
  })
}

export function getCustomerGoodsCostFlowList(querydata) {
  return request({
    url:`${BASE_REQUEST}/getCustomerGoodsCostFlowList`,
    data:querydata
  })
}
export function updateMongoIdx(querydata) {
  return request({
    url:`${BASE_REQUEST}/updateMongoIdx`,
    data:querydata
  })
}

export function saveFlowToCustomerGoods(
  goodsjson
) {
  return request({
    url:`${BASE_REQUEST}/saveFlowToCustomerGoods`,
    data:{goodsjson: goodsjson}
  })
}
export function selecthwzhcluru(costtype,pageNum,pageSize,customerName,sysShiplineId,isStowage,confrim
) {
  return request({
    url: `${BASE_REQUEST}/selecthwzhcluru`,
    data:{
      costtype: costtype,
      pageNum: pageNum,
      pageSize: pageSize,
      customerName:customerName,
      sysShiplineId:sysShiplineId,
      isStowage:isStowage,
      confrim:confrim
    }
  })
}
export function updateCustomerGoodsSourceCost(
  obj
) {
  return request({
    url:`${BASE_REQUEST}/updateCustomerGoodsSourceCost`,
    data:obj
  })
}

export function delCustomerGoodsSourceCost(querydata) {
  return request({
    url:`${BASE_REQUEST}/delCustomerGoodsSourceCost`,
    data:querydata
  })
}
export function selectbyshipid(shiplineid) {
  return request({
    url:`${BASE_REQUEST}/selectbyshipid`,
    data:{shiplineid: shiplineid},
  })
}
export function selectbyshipidbylx(shiplineid) {
  return request({
    url:`${BASE_REQUEST}/selectbyshipidbylx`,
    data:{shiplineid: shiplineid},
  })
}

export function selectbysourceidbylx(sourceid) {
  return request({
    url:`${BASE_REQUEST}/selectbysourceidbylx`,
    data:{sourceid: sourceid},
  })
}

export function selecthwzhclurubyid(cid,sid,id) {
  return request({
    url:`${BASE_REQUEST}/selecthwzhclurubyid`,
    data:{sid: sid,
          cid: cid,
          id:id
    },
  })
}
export function splitcost(cid,tonnage) {
  return request({
    url:`${BASE_REQUEST}/splitcost`,
    data:{tonnage: tonnage,
      cid: cid,
    },
  })
}

export function getCostDetailBySupplierId(querydata) {
  return request({
    url:`${BASE_REQUEST2}/getCostDetailBySupplierId`,
    data:querydata
  })
}
export function getBusinessReceivables(querydata) {
  return request({
    url:`${BASE_REQUEST}/getBusinessReceivables`,
    data:querydata
  })
}
export function getGoodsDetailBusiness(querydata) {
  return request({
    url:`${BASE_REQUEST2}/getGoodsDetailBusiness`,
    data:querydata
  })
}
export function getGoodsDetailForYear(querydata) {
  return request({
    url:`${BASE_REQUEST2}/getGoodsDetailForYear`,
    data:querydata
  })
}
export function editDun(querydata) {
  return request({
    url:`${BASE_REQUEST}/editdun`,
    data:querydata
  })
}

export function updateOrSaveCustomer(list) {
  return request({
    url:`${BASE_REQUEST}/updateOrSaveCustomer`,
    data:{
      list:list
    }
  })
}

export function updateOrSaveCustomerSingleRow(obj) {
  return request({
    url:`${BASE_REQUEST}/updateOrSaveCustomerSingleRow`,
    data:obj
  })
}

export function getBusinessTotal(querydata) {
  return request({
    url:`${BASE_REQUEST}/getBusinessTotal`,
    data:querydata
  })
}

export function removesomecost(costlist) {
  return request({
    url:`${BASE_REQUEST}/removesomecost`,
    data:{
      costlist:costlist
    }
  })
}

export function getFandianStandingBook(querydata) {
  return request({
    url:`${BASE_REQUEST}/getFandianStandingBook`,
    data:querydata
  })
}

export function getCost(id) {
  return request({
    url:`${BASE_REQUEST}/getCost`,
    data:{costId:id}
  })
}
export function getCostByCostIdType(id, invoiceType) {
  return request({
    url:`${BASE_REQUEST}/getCostByCostIdType`,
    data:{costId:id, invoiceType:invoiceType}
  })
}

export function updateCostIsCompleteGoods(querydata) {
  return request({
    url:`${BASE_REQUEST}/updateCostIsCompleteGoods`,
    data:querydata
  })
}

export function removecost(id) {
  return request({
    url:`${BASE_REQUEST}/removecost`,
    data:{
      id:id
    }
  })
}

export function getCustomerGoodsByStowageDataIds(stowageDataIds) {
  return axios({
    headers:{
      "Content-Type":"application/json"
    },
    url: `${BASE_REQUEST}/getCustomerGoodsByStowageDataIds`,
    method: 'post',
    data:{
      stowageDataIds:stowageDataIds
    }
  }) .then(res => {
    if (res !== undefined) {
        return Promise.resolve(res.data)
    } else {
        return Promise.resolve(res)
    }
})
}
export function getAllCostInfo(id) {
  return request({
    url:`${BASE_REQUEST}/getAllCostInfo`,
    data:{
      goodsCostId:id
    }
  })
}

export function getAllCostInfoV2(ids) {
  return request({
    url:`${BASE_REQUEST}/getAllCostInfoV2`,
    data:{
      goodsCostIds:ids
    }
  })
}